export default {
    name: "Condition",
    title: "Condition",
    icon: "mdi-graph-outline",
    create() {
        return {
            name: this.title,
            description: null,
            actionType: this.name,
            conditions: [],
            childAction1: [],
            childAction2: [],
        };
    },
};